import { observer } from 'mobx-react-lite';
import React from 'react';
import { useWebsocketStore } from '../../../../../stores/websocketStore/websocketProvider';
import { tacticNameToWrapperMap } from '../tacticMap/TacticNameToWrapperMap';
interface Map {
  [index: string]: any;
}
interface Props {
  tradePlanId?: string;
  symbol?: string;
  softOrderId?: string;
  componentMap?: Map
}

const isSoftOrderDebugEnabled = () =>
  typeof window !== 'undefined' &&
  (window.config?.REACT_APP_DEBUG_SOFT_ORDERS === 'true' ||
    window.localStorage?.getItem('tuui.debugSoftOrders') === 'true');

const symbolsMatch = (left?: string, right?: string) => {
  if (!right) return true;
  if (!left) return false;

  return `${left}` === `${right}`;
};

const SoftOrderWrapper: React.FC<Props> = observer(({ symbol, softOrderId, componentMap, ...rest }: Props) => {
  const { tradePlanStore } = useWebsocketStore();
  const softOrder = tradePlanStore.softOrdersById[softOrderId];
  if (!softOrder) {
    if (isSoftOrderDebugEnabled()) {
      console.debug('[tuui:softOrders] render missing softOrder', {
        at: new Date().toISOString(),
        softOrderId,
        chartSymbol: symbol,
      });
    }
    return null;
  }
  const tacticName = softOrder.value.tactic;
  const Wrapper = tacticNameToWrapperMap[tacticName];
  const component = componentMap?.[tacticName];
  if (!Wrapper) {
    if (isSoftOrderDebugEnabled()) {
      console.debug('[tuui:softOrders] render missing wrapper', {
        at: new Date().toISOString(),
        softOrderId,
        tactic: tacticName,
        tradePlanId: softOrder.tradePlanId,
        softOrderSymbol: softOrder.value.symbol,
        chartSymbol: symbol,
      });
    }
    return null;
  }
  if (symbol === 'tacticsPanel') return <Wrapper softOrderId={softOrderId} softOrder={softOrder.value.tacticValue} Component={component} completeSoftOrder={softOrder} {...rest}/>;
  if (!symbolsMatch(softOrder.value.symbol, symbol)) {
    if (isSoftOrderDebugEnabled()) {
      console.debug('[tuui:softOrders] render symbol mismatch', {
        at: new Date().toISOString(),
        softOrderId,
        tactic: tacticName,
        tradePlanId: softOrder.tradePlanId,
        softOrderSymbol: softOrder.value.symbol,
        chartSymbol: symbol,
      });
    }
    return null;
  }
  if (isSoftOrderDebugEnabled()) {
    console.debug('[tuui:softOrders] render softOrder', {
      at: new Date().toISOString(),
      softOrderId,
      tactic: tacticName,
      tradePlanId: softOrder.tradePlanId,
      softOrderSymbol: softOrder.value.symbol,
      chartSymbol: symbol,
    });
  }
  return <Wrapper softOrderId={softOrderId} softOrder={softOrder.value.tacticValue} Component={component} completeSoftOrder={softOrder} {...rest}/>;
});


export default SoftOrderWrapper;
